import moment from 'moment';

// Both dates of a postponement are UK calendar days and both are included in it.
export function postponementCoversDay(postponement, day) {
    return moment(day).isBetween(postponement.dateFrom, postponement.dateTo, 'day', '[]');
}
